import { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import FloatingCTA from './FloatingCTA';
import Footer from './Footer';
import Header from './Header';

import spec10ft from '../assets/spec-10ft.jpg';
import spec12ft from '../assets/spec-12ft.jpg';
import spec20ft from '../assets/spec-20ft.jpg';
import spec20fth from '../assets/spec-20fth.jpg';
import spec40ft from '../assets/spec-40ft.jpg';
import spec40fth from '../assets/spec-40fth.jpg';

const containerSpecs = {
  '10ft': [spec10ft],
  '12ft': [spec12ft],
  '20ft': [spec20ft, spec20fth],
  '40ft': [spec40ft, spec40fth],
};

const containerDetails = {
  '10ft': {
    title: '10ft コンテナ',
    description:
      '限られたスペースにも設置しやすい小型コンテナです。倉庫や一時保管など、用途に合わせたご提案が可能です。',
    priceGuide: {
      newPrice: '〇〇万円〜',
      usedPrice: '〇〇万円〜',
    },
    specifications: [
      ['外寸', '長さ 2,991mm × 幅 2,438mm × 高さ 2,591mm'],
      ['内寸', '長さ 2,831mm × 幅 2,352mm × 高さ 2,390mm'],
      ['扉開口', '幅 2,340mm × 高さ 2,280mm'],
      ['内容積', '約15.9m³'],
      ['床面積', '約6.7m²'],
      ['備考', '小規模保管や限られた敷地への設置に適した省スペースサイズ'],
    ],
    features: [
      {
        title: '敷地に収まるサイズ感',
        text: '限られたスペースにも置きやすく、必要な分だけ収納を増やせます。',
      },
      {
        title: '日常使いの保管に',
        text: '工具や備品など、出し入れの多い荷物をすっきりまとめられます。',
      },
      {
        title: '移設しやすい量感',
        text: '搬入動線を確保しやすく、設置場所の変更にも対応しやすいサイズです。',
      },
      {
        title: '小さな倉庫として',
        text: '個人利用から事業用の補助倉庫まで、過不足のない保管空間をつくります。',
      },
    ],
    useCases: [
      '工具収納',
      '資材保管',
      'バックヤード',
      '季節用品',
      'イベント備品',
      '短期在庫',
    ],
  },
  '12ft': {
    title: '12ft コンテナ',
    description:
      '省スペースで扱いやすく、個人利用から事業用の保管スペースまで幅広く活用できるサイズです。',
    priceGuide: {
      newPrice: '〇〇万円〜',
      usedPrice: '〇〇万円〜',
    },
    specifications: [
      ['外寸', '長さ 3,658mm × 幅 2,438mm × 高さ 2,591mm'],
      ['内寸', '長さ 3,498mm × 幅 2,352mm × 高さ 2,390mm'],
      ['扉開口', '幅 2,340mm × 高さ 2,280mm'],
      ['内容積', '約19.7m³'],
      ['床面積', '約8.2m²'],
      ['備考', '省スペース性と収納量のバランスがよい定番サイズ'],
    ],
    features: [
      {
        title: '余裕のある省スペース',
        text: '10ftより収納にゆとりがあり、設置しやすさとのバランスに優れます。',
      },
      {
        title: '出し入れのしやすさ',
        text: '日常的に使う備品や資材を、無理なく整理できる容量です。',
      },
      {
        title: 'まとめて管理できる',
        text: '在庫、什器、作業用品などを一か所に集約しやすくなります。',
      },
      {
        title: '敷地に合わせる',
        text: '店舗や作業場のレイアウトに合わせて、保管場所を整えられます。',
      },
    ],
    useCases: [
      '在庫保管',
      '農機具',
      '作業用品',
      '店舗什器',
      '販促物',
      'アウトドア用品',
    ],
  },
  '20ft': {
    title: '20ft コンテナ',
    description:
      '定番サイズのコンテナです。保管、改装、事務所利用など、さまざまな用途に対応します。',
    priceGuide: {
      newPrice: '〇〇万円〜',
      usedPrice: '〇〇万円〜',
    },
    comparisonCards: [
      {
        label: 'STANDARD',
        title: '標準コンテナ',
        volume: '約33.1m³',
        height: '2,591mm',
        note: '標準サイズ',
      },
      {
        label: 'HIGH CUBE',
        title: 'ハイキューブ',
        volume: '約37.5m³',
        height: '2,896mm',
        note: '内容積 +13% / 高さ +305mm',
      },
    ],
    specifications: [
      {
        label: '外寸',
        standard: '長さ 6,058mm × 幅 2,438mm × 高さ 2,591mm',
        highCube: '長さ 6,058mm × 幅 2,438mm × 高さ 2,896mm',
      },
      {
        label: '内寸',
        standard: '長さ 5,898mm × 幅 2,352mm × 高さ 2,390mm',
        highCube: '長さ 5,898mm × 幅 2,352mm × 高さ 2,698mm',
      },
      {
        label: '扉開口',
        standard: '幅 2,340mm × 高さ 2,280mm',
        highCube: '幅 2,340mm × 高さ 2,585mm',
      },
      {
        label: '内容積',
        standard: '約33.1m³',
        highCube: '約37.5m³',
      },
      {
        label: '床面積',
        standard: '約13.9m²',
        highCube: '約13.9m²',
      },
      {
        label: '備考',
        standard: '保管・改装・作業スペース化まで対応しやすい標準サイズ',
        highCube: '高さを活かした保管や空間づくりに対応しやすい仕様',
      },
    ],
    features: [
      {
        title: '定番サイズで使いやすい',
        text: '保管・改装・事務所利用など、幅広い用途に対応しやすい標準サイズです。',
      },
      {
        title: '収納力と設置性のバランス',
        text: '十分な容量を確保しながら、導入しやすいサイズ感です。',
      },
      {
        title: '加工ベースとしても人気',
        text: '開口加工や内装施工など、用途に合わせたカスタムにも対応しやすいサイズです。',
      },
      {
        title: '事業用途にも対応',
        text: '倉庫、資材置場、作業スペースなど、法人利用にも向いています。',
      },
    ],
    useCases: [
      '資材保管',
      '倉庫',
      '作業スペース',
      '事務所',
      '店舗',
      '防災備蓄',
    ],
  },
  '40ft': {
    title: '40ft コンテナ',
    description:
      '大容量の保管スペースを確保したい場合に適したサイズです。事業用途や大型資材の保管にも向いています。',
    priceGuide: {
      newPrice: '〇〇万円〜',
      usedPrice: '〇〇万円〜',
    },
    comparisonCards: [
      {
        label: 'STANDARD',
        title: '標準コンテナ',
        volume: '約67.7m³',
        height: '2,591mm',
        note: '標準サイズ',
      },
      {
        label: 'HIGH CUBE',
        title: 'ハイキューブ',
        volume: '約76.4m³',
        height: '2,896mm',
        note: '内容積 +13% / 高さ +305mm',
      },
    ],
    specifications: [
      {
        label: '外寸',
        standard: '長さ 12,192mm × 幅 2,438mm × 高さ 2,591mm',
        highCube: '長さ 12,192mm × 幅 2,438mm × 高さ 2,896mm',
      },
      {
        label: '内寸',
        standard: '長さ 12,032mm × 幅 2,352mm × 高さ 2,390mm',
        highCube: '長さ 12,032mm × 幅 2,352mm × 高さ 2,698mm',
      },
      {
        label: '扉開口',
        standard: '幅 2,340mm × 高さ 2,280mm',
        highCube: '幅 2,340mm × 高さ 2,585mm',
      },
      {
        label: '内容積',
        standard: '約67.7m³',
        highCube: '約76.4m³',
      },
      {
        label: '床面積',
        standard: '約28.3m²',
        highCube: '約28.3m²',
      },
      {
        label: '備考',
        standard: 'まとまった保管量が必要な事業用途や大型資材保管に適した大容量サイズ',
        highCube: '高さを活かした大型資材や設備品の保管に適した仕様',
      },
    ],
    features: [
      {
        title: '大容量の保管スペース',
        text: '長尺物や大量の荷物をまとめて保管できる大型サイズです。',
      },
      {
        title: '事業用ストックに対応',
        text: '在庫保管、物流拠点、資材置場など、事業用途に向いています。',
      },
      {
        title: '広さを活かした活用',
        text: '倉庫だけでなく、作業場や改装ベースとしても使いやすいサイズです。',
      },
      {
        title: '長期利用にも適したサイズ感',
        text: 'まとまった保管量が必要な現場や事業所に適しています。',
      },
    ],
    useCases: [
      '大型倉庫',
      '物流拠点',
      '資材保管',
      '建設現場',
      '長尺物保管',
      '事業用ストック',
    ],
  },
};

function ContainerDetail() {
  const { slug } = useParams();
  const detail = containerDetails[slug];
  const specImages = containerSpecs[slug];
  const hasComparisonSpec = detail?.specifications?.some((item) => !Array.isArray(item));
  const hasComparisonCards = Boolean(detail?.comparisonCards);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!detail || !specImages) {
    return (
      <div className="container-detail-page">
        <Header />
        <section className="section container-detail-section">
          <div className="container-detail-container">
            <p className="container-detail-label">CONTAINER TYPE</p>
            <h1 className="container-detail-title">ページが見つかりません</h1>
            <p className="container-detail-text">
              指定されたコンテナタイプは現在準備中です。
            </p>
            <Link to="/" className="container-detail-button">
              トップへ戻る
            </Link>
          </div>
        </section>
        <Footer />
        <FloatingCTA />
      </div>
    );
  }

  return (
    <div className="container-detail-page">
      <Header />
      <section className="section container-detail-section">
        <div className="container-detail-container">
          <header className="container-detail-header">
            <p className="container-detail-label">CONTAINER TYPE</p>
            <h1 className="container-detail-title">{detail.title}</h1>
          </header>

        <figure className="container-detail-figure">
          {specImages.map((specImage, index) => (
            <img
              key={specImage}
              src={specImage}
              alt={`${detail.title} 規格サイズ${index > 0 ? ' ハイキューブ' : ''}`}
              className="container-detail-image"
            />
          ))}
        </figure>

        <section className="container-detail-panel container-detail-price" aria-labelledby="price-guide-title">
          <div className="container-detail-section-head">
            <p className="container-detail-label">PRICE GUIDE</p>
            <h2 id="price-guide-title" className="container-detail-heading">価格目安</h2>
          </div>
          <div className="container-detail-price-grid">
            <article className="container-detail-price-card">
              <p className="container-detail-price-kicker">NEW CONTAINER</p>
              <h3>新品</h3>
              <strong>{detail.priceGuide.newPrice}</strong>
            </article>
            <article className="container-detail-price-card">
              <p className="container-detail-price-kicker">USED CONTAINER</p>
              <h3>中古</h3>
              <strong>{detail.priceGuide.usedPrice}</strong>
            </article>
          </div>
          <div className="container-detail-price-notes">
            <p>※価格は目安です。状態・仕様・在庫状況により変動します。</p>
            <p>※配送費・設置費・加工費は別途となる場合があります。</p>
          </div>
        </section>

        {hasComparisonCards && (
          <section className="container-detail-panel container-detail-comparison" aria-labelledby="comparison-title">
            <div className="container-detail-section-head">
              <p className="container-detail-label">STANDARD / HIGH CUBE</p>
              <h2 id="comparison-title" className="container-detail-heading">高さと容量で選ぶ</h2>
            </div>
            <div className="container-detail-comparison-grid">
              {detail.comparisonCards.map((card) => (
                <article
                  className="container-detail-comparison-card"
                  key={card.label}
                >
                  <p className="container-detail-comparison-label">{card.label}</p>
                  <h3>{card.title}</h3>
                  <div className="container-detail-comparison-metrics">
                    <div>
                      <span>内容積</span>
                      <strong>{card.volume}</strong>
                    </div>
                    <div>
                      <span>高さ</span>
                      <strong>{card.height}</strong>
                    </div>
                  </div>
                  <p className="container-detail-comparison-note">{card.note}</p>
                </article>
              ))}
            </div>
          </section>
        )}

        <section className="container-detail-panel container-detail-specification" aria-labelledby="specification-title">
          <div className="container-detail-section-head">
            <p className="container-detail-label">SPECIFICATION</p>
            <h2 id="specification-title" className="container-detail-heading">規格・寸法</h2>
          </div>
          {hasComparisonSpec ? (
            <div className="container-detail-compare-table" role="table" aria-label={`${detail.title} 規格比較`}>
              <div className="container-detail-compare-head" role="row">
                <div role="columnheader">項目</div>
                <div role="columnheader">
                  <span>STANDARD</span>
                  標準コンテナ
                </div>
                <div role="columnheader">
                  <span>HIGH CUBE</span>
                  ハイキューブ
                </div>
              </div>
              {detail.specifications.map((item) => (
                <div className="container-detail-compare-row" role="row" key={item.label}>
                  <div role="rowheader">{item.label}</div>
                  <div role="cell">{item.standard}</div>
                  <div role="cell">{item.highCube}</div>
                </div>
              ))}
            </div>
          ) : (
            <dl className="container-detail-spec-table">
              {detail.specifications.map(([label, value]) => (
                <div className="container-detail-spec-row" key={label}>
                  <dt>{label}</dt>
                  <dd>{value}</dd>
                </div>
              ))}
            </dl>
          )}
        </section>

        <section className="container-detail-panel" aria-labelledby="features-title">
          <div className="container-detail-section-head">
            <p className="container-detail-label">FEATURES</p>
            <h2 id="features-title" className="container-detail-heading">特徴</h2>
          </div>
          <ul className="container-detail-feature-list">
            {detail.features.map((feature) => (
              <li key={feature.title}>
                <h3>{feature.title}</h3>
                <p>{feature.text}</p>
              </li>
            ))}
          </ul>
        </section>

        <section className="container-detail-panel" aria-labelledby="use-case-title">
          <div className="container-detail-section-head">
            <p className="container-detail-label">USE CASE</p>
            <h2 id="use-case-title" className="container-detail-heading">活用例</h2>
          </div>
          <ul className="container-detail-tag-list">
            {detail.useCases.map((useCase) => (
              <li key={useCase}>{useCase}</li>
            ))}
          </ul>
        </section>

        <div className="container-detail-cta">
          <p className="container-detail-text">{detail.description}</p>
          <a href="/#contact" className="container-detail-button">
            問い合わせる
          </a>
        </div>
        </div>
      </section>
      <Footer />
      <FloatingCTA />
    </div>
  );
}

export default ContainerDetail;
